import React from 'react';
import { ShoppingBag, Heart, Menu, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

const BunnyHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bunny-section-dark border-b-2 border-pink-400 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => navigate('/')}
              className="p-2 hover:bg-white/10 rounded transition-colors"
              aria-label="Back to Waisted Momma"
            >
              <ArrowLeft className="w-5 h-5 text-white" />
            </button>
            <h1 className="text-2xl md:text-3xl font-serif font-bold bunny-headline text-white">
              Waisted <span className="bunny-accent-pink">Bunny</span>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#about" className="font-sans text-sm font-bold text-white hover:text-pink-400 transition-colors tracking-wider">
              ABOUT
            </a>
            <a href="#products" className="font-sans text-sm font-bold text-white hover:text-pink-400 transition-colors tracking-wider">
              SHOP
            </a>
            <a href="#testimonials" className="font-sans text-sm font-bold text-white hover:text-pink-400 transition-colors tracking-wider">
              REVIEWS
            </a>
            <a href="#faq" className="font-sans text-sm font-bold text-white hover:text-pink-400 transition-colors tracking-wider">
              FAQ
            </a>
          </nav>

          {/* Actions */}
          <div className="flex items-center space-x-4">
            <button className="hidden md:block p-2 hover:bg-white/10 rounded transition-colors" aria-label="Wishlist">
              <Heart className="w-5 h-5 text-white" />
            </button>
            <button className="p-2 hover:bg-white/10 rounded transition-colors" aria-label="Shopping cart">
              <ShoppingBag className="w-5 h-5 text-white" />
            </button>
            <button className="md:hidden p-2 hover:bg-white/10 rounded transition-colors" aria-label="Menu">
              <Menu className="w-5 h-5 text-white" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default BunnyHeader;
